import { useEffect, useRef, useState } from "react";
import {
  MapPin,
  Plus,
  RefreshCw,
  X,
  CheckCircle,
  AlertCircle,
  Search,
  Navigation,
  ChevronLeft,
  ChevronRight,
  Filter,
  Eye,
  Minus,
  Trash2,
  Layers,
  Building2,
  Target,
  ChevronUp,
  ChevronDown,
  ChevronsUpDown,
  Edit,
  Save,
} from "lucide-react";
import Select from "react-select";
import Swal from "sweetalert2";

const GeofencesGoogleMaps = () => {
  const mapContainerRef = useRef(null);
  const isInitialized = useRef(false);
  const [toasts, setToasts] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [isDrawing, setIsDrawing] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingGeofence, setEditingGeofence] = useState(null);
  const [userLocation, setUserLocation] = useState({
    lat: -5.1945,
    lng: -80.6328,
  });

  const [modalOpen, setModalOpen] = useState(false);
  const [geofenceSeleccionada, setGeofenceSeleccionada] = useState(null);
  const [establecimientos, setEstablecimientos] = useState([]);
  const [establecimientoSeleccionado, setEstablecimientoSeleccionado] =
    useState(null);
  const [asignando, setAsignando] = useState(false);
  const [cargandoEstablecimientos, setCargandoEstablecimientos] =
    useState(false);
  const [tipoGeocerca, setTipoGeocerca] = useState("INTERNA");
  const [asignacionExistente, setAsignacionExistente] = useState(null);
  const [reasignando, setReasignando] = useState(false);
  const [descripcion, setDescripcion] = useState("");
  const [asignaciones, setAsignaciones] = useState([]);
  const [agregando, setAgregando] = useState(false);
  const [cargandoAsignaciones, setCargandoAsignaciones] = useState(true);

  const [tableSearchQuery, setTableSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [sortField, setSortField] = useState("name");
  const [sortDirection, setSortDirection] = useState("asc");
  const [filteredGeofences, setFilteredGeofences] = useState([]);

  const API_BASE_URL = process.env.REACT_APP_VILOX_FLOTA_API;
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_KEY 
  // ⭐ AGREGAR ESTE USEEFFECT DE DEBUG AL INICIO
  useEffect(() => {
    console.log("🔍 [GEOFENCES DEBUG] Información del entorno:");
    console.log("   Hostname:", window.location.hostname);
    console.log("   API_BASE_URL:", API_BASE_URL);
    console.log(
      "   apiKey:",
      apiKey ? `${apiKey.substring(0, 15)}...` : "❌ NO DEFINIDA",
    );
    console.log(
      "   Google Maps:",
      window.google ? "✅ Ya cargado" : "⏳ No cargado aún",
    );
    console.log("   Versión:", "2 - Con edición");
  }, []);
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setUserLocation({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
          console.log("Ubicación del usuario obtenida:", position.coords);
        },
        (error) => {
          console.log(
            "No se pudo obtener la ubicación, usando Piura por defecto:",
            error,
          );
        },
      );
    }
  }, []);

  const showToast = (message, type = "success") => {
    const id = Date.now();
    const newToast = { id, message, type };
    setToasts((prev) => [...prev, newToast]);

    setTimeout(() => {
      setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }, 3000);
  };

  const removeToast = (id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  };

  const filterAndSortGeofences = () => {
    if (!window.geofences) return [];

    let filtered = window.geofences.filter(
      (geofence) =>
        geofence.name.toLowerCase().includes(tableSearchQuery.toLowerCase()) ||
        geofence.id.toString().includes(tableSearchQuery),
    );

    filtered.sort((a, b) => {
      let aValue = a[sortField];
      let bValue = b[sortField];

      if (sortField === "points") {
        aValue = JSON.parse(a.points || "[]").length;
        bValue = JSON.parse(b.points || "[]").length;
      }

      if (typeof aValue === "string") {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }

      if (sortDirection === "asc") {
        return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
      } else {
        return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
      }
    });

    return filtered;
  };

  const getPaginatedData = () => {
    const filtered = filterAndSortGeofences();
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filtered.slice(startIndex, endIndex);
  };

  const getTotalPages = () => {
    const filtered = filterAndSortGeofences();
    return Math.ceil(filtered.length / itemsPerPage);
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
  };

  const searchLocation = async () => {
    if (!searchQuery.trim() || !window.google) return;

    setIsSearching(true);
    try {
      const service = new window.google.maps.places.PlacesService(window.map);

      const request = {
        query: searchQuery,
        location: new window.google.maps.LatLng(
          userLocation.lat,
          userLocation.lng,
        ),
        radius: 100000,
        language: "es",
        region: "PE",
      };

      service.textSearch(request, (results, status) => {
        if (
          status === window.google.maps.places.PlacesServiceStatus.OK &&
          results.length > 0
        ) {
          const sortedResults = results.sort((a, b) => {
            const distA =
              window.google.maps.geometry.spherical.computeDistanceBetween(
                new window.google.maps.LatLng(
                  userLocation.lat,
                  userLocation.lng,
                ),
                a.geometry.location,
              );
            const distB =
              window.google.maps.geometry.spherical.computeDistanceBetween(
                new window.google.maps.LatLng(
                  userLocation.lat,
                  userLocation.lng,
                ),
                b.geometry.location,
              );
            return distA - distB;
          });

          const location = sortedResults[0].geometry.location;
          const distance =
            window.google.maps.geometry.spherical.computeDistanceBetween(
              new window.google.maps.LatLng(userLocation.lat, userLocation.lng),
              location,
            );

          window.map.setCenter(location);
          window.map.setZoom(14);

          showToast(
            `Ubicación encontrada: ${sortedResults[0].name} (${(
              distance / 1000
            ).toFixed(1)} km)`,
          );
        } else {
          const geocoder = new window.google.maps.Geocoder();
          geocoder.geocode(
            {
              address: searchQuery + ", Piura, Perú",
              region: "PE",
            },
            (results, status) => {
              if (status === "OK" && results[0]) {
                const location = results[0].geometry.location;
                window.map.setCenter(location);
                window.map.setZoom(12);

                showToast(
                  `Ubicación encontrada: ${results[0].formatted_address
                    .split(",")
                    .slice(0, 2)
                    .join(",")}`,
                );
              } else {
                showToast("No se encontró la ubicación en tu área", "error");
              }
              setIsSearching(false);
            },
          );
          return;
        }
        setIsSearching(false);
      });
    } catch (error) {
      console.error("Error searching location:", error);
      showToast("Error al buscar la ubicación", "error");
      setIsSearching(false);
    }
  };

  const getHeaders = () => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  });

  const getApiUrl = () => {
    const apiUrl = process.env.REACT_APP_API_URL;

    if (!apiUrl) {
      console.warn(
        "⚠️ REACT_APP_API_URL no está definida en el archivo .env. Usando fallback http://localhost:8000/api",
      );
      return "http://localhost:8000/api";
    }

    return apiUrl.endsWith("/api") ? apiUrl : `${apiUrl}/api`;
  };

  const handleSearchKeyPress = (e) => {
    if (e.key === "Enter") {
      searchLocation();
    }
  };

  useEffect(() => {
    if (isInitialized.current) return;
    isInitialized.current = true;

    const initializeEverything = async () => {
      try {
        await loadGoogleMapsAPI();
        initializeMap();
        await fetchGeofences();
      } catch (error) {
        console.error("Error initializing:", error);
        showToast("Error al inicializar el mapa", "error");
      }
    };

    initializeEverything();
  }, []);

  useEffect(() => {
    setFilteredGeofences(filterAndSortGeofences());
    setCurrentPage(1);
  }, [tableSearchQuery, sortField, sortDirection]);

  const loadGoogleMapsAPI = () => {
    return new Promise((resolve, reject) => {
      console.log("🚀 [loadGoogleMapsAPI] Iniciando...");

      if (window.google && window.google.maps) {
        console.log("✅ [loadGoogleMapsAPI] Google Maps ya estaba cargado");
        resolve();
        return;
      }

      // ⚠️ VALIDACIÓN CRÍTICA
      if (!apiKey || apiKey === "undefined" || apiKey === "") {
        console.error(
          "❌ [loadGoogleMapsAPI] API Key no está definida:",
          apiKey,
        );
        reject(new Error("Google Maps API Key no configurada"));
        return;
      }

      console.log(
        "📡 [loadGoogleMapsAPI] Creando script con key:",
        apiKey.substring(0, 15) + "...",
      );

      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=drawing,places,geometry&v=3.64`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        console.log("✅ [loadGoogleMapsAPI] Script cargado");
        if (window.google && window.google.maps) {
          console.log("✅ [loadGoogleMapsAPI] Google Maps disponible");
          resolve();
        } else {
          console.error(
            "❌ [loadGoogleMapsAPI] Script cargó pero google.maps no está disponible",
          );
          reject(new Error("Google Maps API failed to load"));
        }
      };

      script.onerror = (error) => {
        console.error("❌ [loadGoogleMapsAPI] Error al cargar script:", error);
        reject(new Error("Google Maps API script failed to load"));
      };

      document.head.appendChild(script);
      console.log("📡 [loadGoogleMapsAPI] Script agregado al DOM");
    });
  };

  const initializeMap = () => {
    console.log("🗺️ [initializeMap] Iniciando...");

    if (!mapContainerRef.current) {
      console.error("❌ [initializeMap] mapContainerRef.current es null");
      return;
    }

    if (!window.google) {
      console.error("❌ [initializeMap] window.google no existe");
      return;
    }

    if (!window.google.maps) {
      console.error("❌ [initializeMap] window.google.maps no existe");
      return;
    }

    try {
      const peruCenter = { lat: -12.0464, lng: -77.0428 };

      console.log("🗺️ [initializeMap] Creando instancia de Google Maps...");
      window.map = new window.google.maps.Map(mapContainerRef.current, {
        zoom: 6,
        center: peruCenter,
        mapTypeId: window.google.maps.MapTypeId.ROADMAP,
        mapTypeControl: true,
        streetViewControl: true,
        fullscreenControl: true,
        zoomControl: true,
        styles: [
          {
            featureType: "poi",
            elementType: "labels",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#e3f2fd" }],
          },
          {
            featureType: "landscape",
            elementType: "geometry",
            stylers: [{ color: "#f5f5f5" }],
          },
        ],
      });

      console.log("✅ [initializeMap] Mapa creado exitosamente");
      initializeDrawingTools();
      console.log("✅ [initializeMap] Drawing tools inicializados");
      showToast("Mapa inicializado correctamente");
    } catch (error) {
      console.error("❌ [initializeMap] Error:", error);
      console.error("Stack:", error.stack);
      showToast("Error al inicializar Google Maps", "error");
    }
  };
  useEffect(() => {
    console.log("🔄 [useEffect Principal] Ejecutando...");

    if (isInitialized.current) {
      console.log("⏭️ [useEffect Principal] Ya inicializado, saltando");
      return;
    }

    isInitialized.current = true;
    console.log("✅ [useEffect Principal] Marcado como inicializado");

    const initializeEverything = async () => {
      try {
        console.log(
          "🚀 [initializeEverything] Iniciando secuencia completa...",
        );

        await loadGoogleMapsAPI();
        console.log("✅ [initializeEverything] Google Maps API cargado");

        initializeMap();
        console.log("✅ [initializeEverything] Mapa inicializado");

        await fetchGeofences();
        console.log("✅ [initializeEverything] Geocercas cargadas");

        console.log("🎉 [initializeEverything] Todo completado exitosamente");
      } catch (error) {
        console.error("❌ [initializeEverything] Error:", error);
        console.error("Stack:", error.stack);
        showToast("Error al inicializar el mapa", "error");
      }
    };

    initializeEverything();
  }, []);
  const initializeDrawingTools = () => {
    if (!window.google || !window.map) return;

    try {
      // Si la librería de dibujo no está disponible, no intentamos instanciar el DrawingManager.
      if (!window.google.maps.drawing || !window.google.maps.drawing.DrawingManager) {
        console.warn("⚠️ La librería de dibujo de Google Maps no está cargada aún.");
        return;
      }

      window.drawingManager = new window.google.maps.drawing.DrawingManager({
        drawingMode: null,
        drawingControl: true,
        drawingControlOptions: {
          position: window.google.maps.ControlPosition.TOP_CENTER,
          drawingModes: [window.google.maps.drawing.OverlayType.POLYGON],
        },
        polygonOptions: {
          fillColor: "#3b82f6",
          fillOpacity: 0.3,
          strokeColor: "#3b82f6",
          strokeWeight: 2,
          clickable: true,
          editable: true,
          draggable: false,
        },
      });

      window.drawingManager.setMap(window.map);
      window.drawnPolygons = [];

      window.drawingManager.addListener("polygoncomplete", (polygon) => {
        window.drawnPolygons.forEach((poly) => poly.setMap(null));
        window.drawnPolygons = [];
        window.drawnPolygons.push(polygon);

        const path = polygon.getPath();
        const coords = [];

        for (let i = 0; i < path.getLength(); i++) {
          const latLng = path.getAt(i);
          coords.push([latLng.lat(), latLng.lng()]);
        }

        if (coords.length < 3) {
          showToast("El polígono debe tener al menos 3 puntos.", "error");
          polygon.setMap(null);
          return;
        }

        window.currentPolygonPoints = coords;

        const pointsInfo = document.getElementById("pointsInfo");
        if (pointsInfo) {
          pointsInfo.textContent = `Polígono dibujado con ${coords.length} puntos. Listo para crear.`;
        }

        showToast(`Polígono creado con ${coords.length} puntos`);
        window.drawingManager.setDrawingMode(null);
        setIsDrawing(false);
        polygon.setEditable(true);

        window.google.maps.event.addListener(
          polygon.getPath(),
          "set_at",
          () => {
            updatePolygonCoords(polygon);
          },
        );

        window.google.maps.event.addListener(
          polygon.getPath(),
          "insert_at",
          () => {
            updatePolygonCoords(polygon);
          },
        );
      });

      window.drawingManager.addListener("drawingmode_changed", () => {
        const mode = window.drawingManager.getDrawingMode();
        setIsDrawing(mode === window.google.maps.drawing.OverlayType.POLYGON);
      });

      console.log("Drawing tools initialized successfully");
    } catch (error) {
      console.error("Error initializing drawing tools:", error);
      // No alertar al usuario si es solo un warning de carga inicial no crítico
    }
  };

  const updatePolygonCoords = (polygon) => {
    const path = polygon.getPath();
    const coords = [];

    for (let i = 0; i < path.getLength(); i++) {
      const latLng = path.getAt(i);
      coords.push([latLng.lat(), latLng.lng()]);
    }

    window.currentPolygonPoints = coords;

    const pointsInfo = document.getElementById("pointsInfo");
    if (pointsInfo) {
      pointsInfo.textContent = `Polígono modificado: ${coords.length} puntos.`;
    }
  };

  const fetchGeofences = async () => {
    console.log("URL de Geofences:", `${API_BASE_URL}/api/geofences`);
    try {
      const response = await fetch(`${API_BASE_URL}/api/geofences`, { headers: getHeaders() });
      if (!response.ok) throw new Error(`HTTP error: ${response.status}`);

      const geofences = await response.json();
      window.geofences = geofences;

      displayGeofences();
      setFilteredGeofences(filterAndSortGeofences());
    } catch (error) {
      console.error("Error fetching geofences:", error);

      window.geofences = [
        {
          id: 117,
          name: "BETA OLMOS EXTERNO",
          points: JSON.stringify([
            [-6.134859085850551, -79.97658898568986],
            [-6.135061766282413, -79.97648169732926],
            [-6.134155037435833, -79.97410526014207],
            [-6.133968357775968, -79.97418036199448],
          ]),
        },
      ];

      displayGeofences();
      setFilteredGeofences(filterAndSortGeofences());
      showToast("Usando datos de prueba para geocercas", "error");
    }
  };

  const displayGeofences = () => {
    if (!window.map || !window.geofences || !window.google) return;

    if (window.geofencePolygons) {
      window.geofencePolygons.forEach((polygon) => polygon.setMap(null));
    }
    window.geofencePolygons = [];

    if (window.geofenceLabels) {
      window.geofenceLabels.forEach((label) => label.setMap(null));
    }
    window.geofenceLabels = [];

    const bounds = new window.google.maps.LatLngBounds();

    window.geofences.forEach((geofence) => {
      try {
        let points = geofence.points;
        if (typeof points === 'string') points = JSON.parse(points);
        if (typeof points === 'string') points = JSON.parse(points);
        const coords = points.map((p) => ({ lat: p[0], lng: p[1] }));

        const polygon = new window.google.maps.Polygon({
          paths: coords,
          strokeColor: "#3b82f6",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#3b82f6",
          fillOpacity: 0.2,
          clickable: true,
        });
        polygon.setMap(window.map);
        polygon.geofenceId = geofence.id;
        window.geofencePolygons.push(polygon);

        let centerLat = 0,
          centerLng = 0;
        coords.forEach((coord) => {
          bounds.extend(coord);
          centerLat += coord.lat;
          centerLng += coord.lng;
        });
        const center = {
          lat: centerLat / coords.length,
          lng: centerLng / coords.length,
        };

        class CustomLabel extends window.google.maps.OverlayView {
          constructor(position, text) {
            super();
            this.position = position;
            this.text = text;
            this.div = null;
          }

          onAdd() {
            const div = document.createElement("div");
            div.style.position = "absolute";
            div.style.backgroundColor = "rgba(59, 130, 246, 0.95)";
            div.style.color = "white";
            div.style.padding = "6px 12px";
            div.style.borderRadius = "6px";
            div.style.fontSize = "12px";
            div.style.fontWeight = "700";
            div.style.whiteSpace = "nowrap";
            div.style.boxShadow = "0 2px 8px rgba(0,0,0,0.25)";
            div.style.border = "2px solid #ffffff";
            div.style.fontFamily = "'Inter', -apple-system, sans-serif";
            div.style.userSelect = "none";
            div.style.zIndex = "1000";
            div.style.pointerEvents = "none";

            div.textContent = this.text;
            this.div = div;

            this.getPanes().overlayMouseTarget.appendChild(div);
          }

          draw() {
            if (!this.div) return;
            const overlayProjection = this.getProjection();
            const pos = overlayProjection.fromLatLngToDivPixel(
              new window.google.maps.LatLng(
                this.position.lat,
                this.position.lng,
              ),
            );
            this.div.style.left = pos.x - this.div.offsetWidth / 2 + "px";
            this.div.style.top = pos.y - this.div.offsetHeight / 2 + "px";
          }

          onRemove() {
            if (this.div) {
              this.div.parentNode.removeChild(this.div);
              this.div = null;
            }
          }
        }

        const customLabel = new CustomLabel(center, `${geofence.id}`);
        customLabel.setMap(window.map);
        window.geofenceLabels.push(customLabel);

        class TooltipOverlay extends window.google.maps.OverlayView {
          constructor(position, text) {
            super();
            this.position = position;
            this.text = text;
            this.div = null;
          }

          onAdd() {
            const div = document.createElement("div");
            div.style.position = "absolute";
            div.style.padding = "4px 8px";
            div.style.backgroundColor = "rgba(0,0,0,0.75)";
            div.style.color = "white";
            div.style.fontSize = "12px";
            div.style.borderRadius = "4px";
            div.style.whiteSpace = "nowrap";
            div.style.pointerEvents = "none";
            div.style.opacity = "0";
            div.style.transition = "opacity 0.2s";
            div.style.zIndex = "1000";
            div.textContent = this.text;
            this.div = div;

            this.getPanes().floatPane.appendChild(div);
          }

          draw() {
            if (!this.div) return;
            const overlayProjection = this.getProjection();
            const pos = overlayProjection.fromLatLngToDivPixel(
              new window.google.maps.LatLng(
                this.position.lat,
                this.position.lng,
              ),
            );
            this.div.style.left = pos.x + "px";
            this.div.style.top = pos.y - 30 + "px";
          }

          onRemove() {
            if (this.div) {
              this.div.parentNode.removeChild(this.div);
              this.div = null;
            }
          }
        }

        const tooltip = new TooltipOverlay(center, geofence.name);
        tooltip.setMap(window.map);

        polygon.addListener("mouseover", () => {
          tooltip.div.style.opacity = "1";
        });
        polygon.addListener("mouseout", () => {
          tooltip.div.style.opacity = "0";
        });

        const infoWindow = new window.google.maps.InfoWindow({
          content: `
          <div style="padding: 8px; min-width: 150px; font-family: 'Inter', sans-serif;">
            <h3 style="margin: 0 0 4px 0; font-weight: 600; color: #1f2937; font-size: 14px;">${geofence.name}</h3>
            <p style="margin: 2px 0; font-size: 11px; color: #6b7280;">${coords.length} puntos</p>
            <div style="margin-top: 4px; padding-top: 4px; border-top: 1px solid #e5e7eb;">
              <span style="font-size: 10px; color: #9ca3af;">ID: ${geofence.id}</span>
            </div>
          </div>
        `,
        });

        polygon.addListener("click", (event) => {
          infoWindow.setPosition(event.latLng);
          infoWindow.open(window.map);
        });
      } catch (error) {
        console.error("Error displaying geofence:", error);
      }
    });

    if (window.geofences.length > 0 && !bounds.isEmpty()) {
      window.map.fitBounds(bounds, { padding: 50 });
    }
  };

  window.zoomToGeofence = (geofenceId) => {
    const geofence = window.geofences.find((g) => g.id === geofenceId);
    if (!geofence || !window.google || !window.map) return;

    try {
      const mapContainer = mapContainerRef.current;
      if (mapContainer) {
        mapContainer.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }

      setTimeout(() => {
        let points = geofence.points;
        if (typeof points === 'string') points = JSON.parse(points);
        if (typeof points === 'string') points = JSON.parse(points);
        const bounds = new window.google.maps.LatLngBounds();

        points.forEach((point) => {
          bounds.extend({ lat: point[0], lng: point[1] });
        });

        window.map.fitBounds(bounds, { padding: 150 });

        setTimeout(() => {
          if (window.map.getZoom() > 15) {
            window.map.setZoom(15);
          }
        }, 100);

        showToast(`Mostrando geocerca: ${geofence.name}`);
      }, 300);
    } catch (error) {
      console.error("Error zooming to geofence:", error);
      showToast("Error al mostrar la geocerca", "error");
    }
  };

  // Nueva función para iniciar edición
  const startEditingGeofence = (geofenceId) => {
    const geofence = window.geofences.find((g) => g.id === geofenceId);
    if (!geofence || !window.google || !window.map) return;

    try {
      // Cancelar cualquier modo de dibujo activo
      if (window.drawingManager) {
        window.drawingManager.setDrawingMode(null);
      }
      setIsDrawing(false);

      // Limpiar polígonos temporales
      if (window.drawnPolygons) {
        window.drawnPolygons.forEach((poly) => poly.setMap(null));
        window.drawnPolygons = [];
      }

      // Encontrar el polígono en el mapa
      const polygon = window.geofencePolygons.find(
        (p) => p.geofenceId === geofenceId,
      );

      if (!polygon) {
        showToast("No se encontró el polígono en el mapa", "error");
        return;
      }

      // Hacer el polígono editable
      polygon.setEditable(true);
      polygon.setDraggable(false);

      // Cambiar estilo para indicar modo edición
      polygon.setOptions({
        strokeColor: "#f59e0b",
        fillColor: "#f59e0b",
        strokeWeight: 3,
      });

      // Centrar mapa en el polígono
      let points = geofence.points;
      if (typeof points === 'string') points = JSON.parse(points);
      if (typeof points === 'string') points = JSON.parse(points);
      const bounds = new window.google.maps.LatLngBounds();
      points.forEach((point) => {
        bounds.extend({ lat: point[0], lng: point[1] });
      });
      window.map.fitBounds(bounds, { padding: 100 });

      // Guardar referencia al polígono editado
      window.editingPolygon = polygon;

      // Actualizar coordenadas cuando se edita
      const updateCoords = () => {
        const path = polygon.getPath();
        const coords = [];
        for (let i = 0; i < path.getLength(); i++) {
          const latLng = path.getAt(i);
          coords.push([latLng.lat(), latLng.lng()]);
        }
        window.currentPolygonPoints = coords;

        const pointsInfo = document.getElementById("editPointsInfo");
        if (pointsInfo) {
          pointsInfo.textContent = `Editando: ${coords.length} puntos`;
        }
      };

      window.google.maps.event.addListener(
        polygon.getPath(),
        "set_at",
        updateCoords,
      );
      window.google.maps.event.addListener(
        polygon.getPath(),
        "insert_at",
        updateCoords,
      );
      window.google.maps.event.addListener(
        polygon.getPath(),
        "remove_at",
        updateCoords,
      );

      // Inicializar coordenadas actuales
      updateCoords();

      setIsEditing(true);
      setEditingGeofence(geofence);

      showToast(`Editando geocerca: ${geofence.name}`, "success");

      // Scroll al formulario de edición
      setTimeout(() => {
        const editForm = document.getElementById("editForm");
        if (editForm) {
          editForm.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 300);
    } catch (error) {
      console.error("Error starting edit:", error);
      showToast("Error al iniciar edición", "error");
    }
  };

  // Nueva función para guardar edición
  const saveEditedGeofence = async () => {
    if (!editingGeofence || !window.currentPolygonPoints) {
      showToast("No hay cambios para guardar", "error");
      return;
    }

    if (window.currentPolygonPoints.length < 3) {
      showToast("El polígono debe tener al menos 3 puntos", "error");
      return;
    }

    try {
      const updatedGeofence = {
        id: editingGeofence.id,
        imei: editingGeofence.imei || "123456789012345",
        name: editingGeofence.name,
        alarmtype: editingGeofence.alarmtype || 2,
        points: window.currentPolygonPoints,
      };

      console.log("Actualizando geocerca:", updatedGeofence);

      const response = await fetch(
        `${API_BASE_URL}/api/geofences/${editingGeofence.id}`,
        {
          method: "PUT",
          headers: getHeaders(),
          body: JSON.stringify(updatedGeofence),
        },
      );

      if (response.ok) {
        showToast("Geocerca actualizada exitosamente");
        cancelEditingGeofence();
        await fetchGeofences();
      } else {
        throw new Error(`Error HTTP: ${response.status}`);
      }
    } catch (error) {
      console.error("Error al actualizar geocerca:", error);
      showToast("Error al actualizar la geocerca", "error");
    }
  };

  // Nueva función para cancelar edición
  const cancelEditingGeofence = () => {
    if (window.editingPolygon) {
      window.editingPolygon.setEditable(false);
      window.editingPolygon.setOptions({
        strokeColor: "#3b82f6",
        fillColor: "#3b82f6",
        strokeWeight: 2,
      });
      window.editingPolygon = null;
    }

    window.currentPolygonPoints = null;
    setIsEditing(false);
    setEditingGeofence(null);

    const pointsInfo = document.getElementById("editPointsInfo");
    if (pointsInfo) {
      pointsInfo.textContent = "";
    }

    showToast("Edición cancelada");
  };
  const handleFormSubmit = async (event) => {
    event.preventDefault();

    if (
      !window.currentPolygonPoints ||
      window.currentPolygonPoints.length < 3
    ) {
      showToast("Por favor dibuja un polígono con al menos 3 puntos.", "error");
      return;
    }

    const formData = new FormData(event.target);

    const geofence = {
      imei: "123456789012345",
      name: formData.get("name"),
      alarmtype: 2,
      points: window.currentPolygonPoints,
    };

    try {
      console.log("Creando geocerca:", geofence);

      const response = await fetch(`${API_BASE_URL}/api/geofences`, {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(geofence),
      });

      console.log(
        "Respuesta del servidor:",
        response.status,
        response.statusText,
      );

      if (response.ok) {
        let result;
        let rawResponse;

        try {
          rawResponse = await response.text();
          console.log("Respuesta RAW del servidor:", rawResponse);

          try {
            result = JSON.parse(rawResponse);
            console.log("Respuesta parseada como JSON:", result);
          } catch {
            result = rawResponse;
            console.log("Respuesta no es JSON, se usa como texto plano");
          }

          showToast("Geocerca creada exitosamente en la base de datos");
          console.log("Resultado final interpretado:", result);

          clearForm();
          await fetchGeofences();
        } catch (parseError) {
          console.error(
            "Error al procesar respuesta del servidor:",
            parseError,
          );
          showToast("Error procesando la respuesta del servidor", "error");
        }
      } else {
        let errorDetails;
        try {
          errorDetails = await response.json();
          console.error("Error JSON del servidor:", errorDetails);
        } catch {
          errorDetails = await response.text();
          console.error("Error TEXT del servidor:", errorDetails);
        }

        const errorMessage =
          errorDetails?.message ||
          errorDetails?.error ||
          errorDetails ||
          "Error desconocido del servidor";
        showToast(`Error HTTP ${response.status}: ${errorMessage}`, "error");

        throw new Error(`Server error: ${response.status} - ${errorMessage}`);
      }
    } catch (error) {
      console.error("Error completo al crear geocerca:", error);

      if (error.name === "TypeError" || error.message.includes("fetch")) {
        showToast(
          "Error de conexión: Verifica que tu API esté funcionando",
          "error",
        );
      } else if (error.message.includes("400")) {
        console.log("ERROR 400 - Bad Request detectado!");
        console.log(
          "Datos completos enviados:",
          JSON.stringify(geofence, null, 2),
        );
        return;
      } else {
        showToast(`Error del servidor: ${error.message}`, "error");
      }

      const newGeofence = {
        id: Date.now(),
        ...geofence,
      };

      if (!window.geofences) window.geofences = [];
      window.geofences.push(newGeofence);

      displayGeofences();
      setFilteredGeofences(filterAndSortGeofences());

      showToast("Geocerca guardada en modo demostración (API no disponible)");
      clearForm();
    }
  };

  const fetchAsignaciones = async (geofenceId) => {
    try {
      setCargandoAsignaciones(true);

      const response = await fetch(
        `${getApiUrl()}/geocercas-establecimientos/por-geocerca/${geofenceId}`,
        { headers: getHeaders() },
      );

      if (!response.ok) throw new Error("Error al cargar asignaciones");

      const data = await response.json();

      if (data.success) {
        setAsignaciones(data.data || []);
      } else {
        setAsignaciones([]);
        console.warn("⚠️ No se devolvieron asignaciones");
      }
    } catch (error) {
      console.error("❌ Error al cargar asignaciones:", error);
      showToast("Error al cargar asignaciones", "error");
    } finally {
      // 🔹 Desactivar loading (con un leve delay para suavizar UX)
      setTimeout(() => setCargandoAsignaciones(false), 400);
    }
  };

  const fetchEstablecimientos = async () => {
    try {
      const response = await fetch(
        `${getApiUrl()}/geocercas-establecimientos/establecimientos-disponibles`,
        {
          method: "GET",
          headers: getHeaders(),
        },
      );

      if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);

      const data = await response.json();
      const establecimientosData = data.data || data;

      setEstablecimientos(
        establecimientosData.map((e) => ({
          value: e.id,
          label: e.nombre,
        })),
      );

      console.log("✅ Establecimientos cargados:", establecimientosData);
    } catch (error) {
      console.error("❌ Error al cargar establecimientos:", error);
      showToast("Error al cargar establecimientos", "error");
    }
  };

  const abrirModalAsignar = async (geofence) => {
    setGeofenceSeleccionada(geofence);
    setModalOpen(true);
    setAgregando(false);
    setAsignaciones([]);
    setDescripcion("");
    setTipoGeocerca("INTERNA");

    // ✅ Cargar asignaciones existentes al abrir
    await fetchAsignaciones(geofence.id);
  };

  const asignarEstablecimiento = async () => {
    if (!establecimientoSeleccionado || !geofenceSeleccionada) {
      showToast("Selecciona un establecimiento", "error");
      return;
    }

    if (!tipoGeocerca) {
      showToast("Selecciona el tipo de geocerca", "error");
      return;
    }

    setAsignando(true);

    try {
      const response = await fetch(
        `${getApiUrl()}/geocercas-establecimientos/asignar`,
        {
          method: "POST",
          headers: getHeaders(),
          body: JSON.stringify({
            geocerca_id: geofenceSeleccionada.id,
            establecimiento_id: establecimientoSeleccionado.value,
            tipo: tipoGeocerca,
            descripcion,
          }),
        },
      );

      if (!response.ok) {
        const errorText = await response.text();
        console.error(
          "❌ Error en respuesta HTTP:",
          response.status,
          errorText,
        );
        throw new Error(`Error HTTP ${response.status}`);
      }

      const data = await response.json();

      if (data.success) {
        showToast("✅ Establecimiento asignado correctamente");
        setModalOpen(false);
        await fetchGeofences();
      } else {
        showToast(data.message || "Error al asignar establecimiento", "error");
      }
    } catch (error) {
      console.error("❌ Error al asignar establecimiento:", error);
      showToast("No se pudo asignar el establecimiento", "error");
    } finally {
      setAsignando(false);
    }
  };

  const eliminarAsignacion = async (idUuid) => {
    // ✅ Validar que el ID existe
    if (!idUuid) {
      console.error("❌ ID de asignación no válido:", idUuid);
      showToast("Error: ID de asignación no válido", "error");
      return;
    }

    const confirm = await Swal.fire({
      title: "¿Eliminar asignación?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
    });

    if (!confirm.isConfirmed) return;

    try {
      console.log("🗑️ Eliminando asignación con ID:", idUuid); // ✅ Log para debug

      const response = await fetch(
        `${getApiUrl()}/geocercas-establecimientos/${idUuid}`,
        {
          method: "DELETE",
          headers: getHeaders(),
        },
      );

      console.log("📡 Respuesta DELETE:", response.status); // ✅ Log para debug

      if (response.ok) {
        showToast("✅ Asignación eliminada correctamente");
        await fetchAsignaciones(geofenceSeleccionada.id);
      } else {
        const errorData = await response.json();
        console.error("❌ Error del servidor:", errorData);
        showToast(errorData.message || "Error al eliminar asignación", "error");
      }
    } catch (error) {
      console.error("❌ Error al eliminar asignación:", error);
      showToast("Error al eliminar asignación", "error");
    }
  };

  const clearForm = () => {
    const form = document.querySelector("form");
    if (form) form.reset();

    if (window.drawnPolygons) {
      window.drawnPolygons.forEach((polygon) => polygon.setMap(null));
      window.drawnPolygons = [];
    }

    window.currentPolygonPoints = null;

    const pointsInfo = document.getElementById("pointsInfo");
    if (pointsInfo) {
      pointsInfo.textContent =
        "Dibuja tu polígono en el mapa usando la herramienta de dibujo.";
    }
  };

  const toggleDrawingMode = () => {
    if (!window.drawingManager) return;

    if (isDrawing) {
      window.drawingManager.setDrawingMode(null);
      setIsDrawing(false);
    } else {
      window.drawingManager.setDrawingMode(
        window.google.maps.drawing.OverlayType.POLYGON,
      );
      setIsDrawing(true);
    }
  };

  window.deleteGeofence = async (geofenceId) => {
    if (!window.confirm("¿Estás seguro de que quieres eliminar esta geocerca?"))
      return;

    try {
      console.log("Intentando eliminar geocerca ID:", geofenceId);

      const response = await fetch(
        `${API_BASE_URL}/api/geofences/${geofenceId}`,
        {
          method: "DELETE",
          headers: getHeaders(),
        },
      );

      console.log(
        "Respuesta del servidor (DELETE):",
        response.status,
        response.statusText,
      );

      if (response.ok) {
        console.log("Geocerca eliminada exitosamente de la base de datos");
        showToast("Geocerca eliminada exitosamente de la base de datos");
        await fetchGeofences();
      } else {
        const errorText = await response.text();
        console.error(
          "Error del servidor al eliminar:",
          response.status,
          errorText,
        );
        throw new Error(`Server error: ${response.status} - ${errorText}`);
      }
    } catch (error) {
      console.error("Error completo al eliminar geocerca:", error);

      if (error.name === "TypeError" || error.message.includes("fetch")) {
        showToast("Error de conexión: No se pudo conectar con la API", "error");
      } else {
        showToast(`Error del servidor: ${error.message}`, "error");
      }

      showToast("Geocerca eliminada solo del frontend (API no disponible)");
    }

    if (window.geofences) {
      window.geofences = window.geofences.filter((g) => g.id !== geofenceId);
      displayGeofences();
      setFilteredGeofences(filterAndSortGeofences());
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50 p-2">
      {/* Toast Container */}
      <div className="fixed top-2 right-2 z-50 space-y-1">
        {toasts.map((toast) => (
          <div
            key={toast.id}
            className={`flex items-center gap-2 px-3 py-2 rounded-lg shadow-lg backdrop-blur-sm max-w-sm animate-in slide-in-from-right-full duration-300 ${
              toast.type === "error"
                ? "bg-red-500/90 text-white border border-red-400"
                : "bg-emerald-500/90 text-white border border-emerald-400"
            }`}
          >
            {toast.type === "error" ? (
              <AlertCircle className="w-4 h-4 flex-shrink-0" />
            ) : (
              <CheckCircle className="w-4 h-4 flex-shrink-0" />
            )}
            <span className="text-sm font-medium">{toast.message}</span>
            <button
              onClick={() => removeToast(toast.id)}
              className="ml-auto p-1 hover:bg-white/20 rounded-lg transition-colors"
            >
              <X className="w-3 h-3" />
            </button>
          </div>
        ))}
      </div>

      {/* Header Compacto */}
      <div className="bg-white/70 backdrop-blur-md p-3 rounded-xl shadow-lg border border-white/20 mb-3">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent flex items-center">
              <MapPin className="mr-2 h-6 w-6 text-blue-500" />
              Gestión de Geocercas
            </h1>
            <p className="text-gray-600 mt-1 text-sm">
              Crear y administrar zonas geográficas para monitoreo
            </p>
          </div>
          <div className="bg-gradient-to-r from-blue-500 to-indigo-500 p-2 rounded-xl">
            <Layers className="h-6 w-6 text-white" />
          </div>
        </div>
      </div>

      {/* Layout Principal Compacto */}
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-3 mb-3">
        {/* Panel de Controles Compacto */}
        <div className="xl:col-span-1 space-y-3">
          {/* Buscador Compacto */}
          <div className="bg-white/70 backdrop-blur-md p-3 rounded-xl shadow-lg border border-white/20">
            <h3 className="text-lg font-bold text-gray-900 mb-2 flex items-center">
              <Search className="mr-2 h-5 w-5 text-blue-500" />
              Buscar Ubicación
            </h3>
            <div className="space-y-2">
              <div className="relative group">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400 group-focus-within:text-blue-500 transition-colors" />
                <input
                  type="text"
                  placeholder="Ej: NEPTUNIA, RAPEL, Plaza de Armas..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyPress={handleSearchKeyPress}
                  className="w-full pl-10 pr-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white/50 backdrop-blur-sm transition-all text-sm"
                />
              </div>
              <button
                onClick={searchLocation}
                disabled={isSearching}
                className="w-full bg-gradient-to-r from-blue-500 to-indigo-500 text-white px-4 py-2 rounded-lg hover:from-blue-600 hover:to-indigo-600 disabled:opacity-50 flex items-center justify-center font-medium transition-all transform hover:scale-105 text-sm"
              >
                <Navigation className="h-4 w-4 mr-1" />
                {isSearching ? "Buscando..." : "Ir a Ubicación"}
              </button>
            </div>
          </div>

          {/* Controles de Dibujo Compactos */}
          <div className="bg-white/70 backdrop-blur-md p-3 rounded-xl shadow-lg border border-white/20">
            <h3 className="text-lg font-bold text-gray-900 mb-2 flex items-center">
              <Target className="mr-2 h-5 w-5 text-green-500" />
              Herramientas
            </h3>
            <button
              onClick={toggleDrawingMode}
              disabled={isEditing}
              className={`w-full px-4 py-2 rounded-lg font-medium transition-all transform hover:scale-105 text-sm ${
                isDrawing
                  ? "bg-gradient-to-r from-red-500 to-pink-500 text-white hover:from-red-600 hover:to-pink-600"
                  : "bg-gradient-to-r from-green-500 to-emerald-500 text-white hover:from-green-600 hover:to-emerald-600"
              } ${isEditing ? "opacity-50 cursor-not-allowed" : ""}`}
            >
              {isDrawing ? "Cancelar Dibujo" : "Dibujar Polígono"}
            </button>
            <p className="text-xs text-gray-600 mt-2 p-2 bg-blue-50 rounded border-l-2 border-blue-400">
              {isEditing
                ? "Modo edición activo"
                : isDrawing
                  ? "Haz clic en el mapa para crear puntos"
                  : "Activa el modo de dibujo para crear geocerca"}
            </p>
          </div>

          {/* Panel de Edición */}
          {isEditing && editingGeofence && (
            <div
              id="editForm"
              className="bg-amber-50/70 backdrop-blur-md p-3 rounded-xl shadow-lg border-2 border-amber-400"
            >
              <h3 className="text-lg font-bold text-amber-900 mb-2 flex items-center">
                <Edit className="mr-2 h-5 w-5 text-amber-600" />
                Editando: {editingGeofence.name}
              </h3>

              <div className="bg-white/70 rounded-lg p-3 mb-3 border border-amber-200">
                <div className="flex items-start">
                  <MapPin className="h-4 w-4 text-amber-600 mr-2 mt-0.5 flex-shrink-0" />
                  <div>
                    <p className="text-xs font-semibold text-amber-900">
                      Estado del Polígono
                    </p>
                    <p
                      id="editPointsInfo"
                      className="text-xs text-amber-700 mt-0.5"
                    >
                      Editando...
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-r from-amber-100 to-yellow-100 rounded-lg p-2 mb-3">
                <p className="text-xs text-amber-800">
                  💡 <strong>Instrucciones:</strong> Arrastra los puntos del
                  polígono para modificarlo. Haz clic en un punto para
                  eliminarlo (mantén al menos 3 puntos).
                </p>
              </div>

              <div className="flex gap-2">
                <button
                  onClick={saveEditedGeofence}
                  className="flex-1 bg-gradient-to-r from-green-500 to-emerald-500 text-white px-4 py-2 rounded-lg hover:from-green-600 hover:to-emerald-600 transition-all flex items-center justify-center font-medium transform hover:scale-105 text-sm"
                >
                  <Save className="mr-1 h-4 w-4" />
                  Guardar Cambios
                </button>

                <button
                  onClick={cancelEditingGeofence}
                  className="bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition-all flex items-center justify-center font-medium transform hover:scale-105 text-sm"
                >
                  <X className="mr-1 h-4 w-4" />
                  Cancelar
                </button>
              </div>
            </div>
          )}

          {/* Formulario Compacto */}
          <div className="bg-white/70 backdrop-blur-md p-3 rounded-xl shadow-lg border border-white/20">
            <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center">
              <Plus className="mr-2 h-5 w-5 text-green-500" />
              Nueva Geocerca
            </h3>

            <form onSubmit={handleFormSubmit} className="space-y-3">
              <div>
                <label
                  htmlFor="nameInput"
                  className="block text-xs font-semibold text-gray-700 mb-1"
                >
                  Nombre de la Zona
                </label>
                <input
                  type="text"
                  id="nameInput"
                  name="name"
                  placeholder="Ej: Zona Centro Lima"
                  className="w-full border border-gray-200 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white/50 backdrop-blur-sm transition-all text-sm"
                  required
                />
              </div>

              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-2">
                <div className="flex items-start">
                  <MapPin className="h-4 w-4 text-blue-500 mr-2 mt-0.5 flex-shrink-0" />
                  <div>
                    <p className="text-xs font-semibold text-blue-900">
                      Estado del Polígono
                    </p>
                    <p id="pointsInfo" className="text-xs text-blue-700 mt-0.5">
                      Dibuja tu polígono en el mapa usando la herramienta de
                      dibujo.
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex space-x-2">
                <button
                  type="submit"
                  className="flex-1 bg-gradient-to-r from-green-500 to-emerald-500 text-white px-4 py-2 rounded-lg hover:from-green-600 hover:to-emerald-600 transition-all flex items-center justify-center font-medium transform hover:scale-105 text-sm"
                >
                  <Plus className="mr-1 h-4 w-4" />
                  Crear
                </button>

                <button
                  type="button"
                  onClick={clearForm}
                  className="bg-gray-500 text-white px-3 py-2 rounded-lg hover:bg-gray-600 transition-all transform hover:scale-105"
                >
                  <RefreshCw className="h-4 w-4" />
                </button>
              </div>
            </form>
          </div>

          {/* Estadísticas Compactas */}
          <div className="bg-gradient-to-r from-purple-500 to-pink-500 p-3 rounded-xl shadow-lg text-white">
            <h3 className="text-sm font-bold mb-2 flex items-center">
              <Layers className="mr-1 h-4 w-4" />
              Estado Actual
            </h3>
            <div className="bg-white/20 backdrop-blur-sm rounded-lg p-2">
              <div className="flex justify-between items-center">
                <span className="text-xs font-medium">Geocercas activas:</span>
                <span className="text-xl font-bold" id="totalGeofences">
                  {window.geofences ? window.geofences.length : 0}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Mapa Google Maps Compacto */}
        <div className="xl:col-span-2">
          <div className="bg-white/70 backdrop-blur-md rounded-xl shadow-lg border border-white/20 overflow-hidden h-full">
            <div className="bg-gradient-to-r from-blue-500 to-indigo-500 px-4 py-3 text-white">
              <h3 className="text-lg font-bold flex items-center">
                <Navigation className="mr-2 h-5 w-5" />
                Mapa Interactivo
              </h3>
              <p className="text-blue-100 mt-0.5 text-sm">
                Usa las herramientas de dibujo integradas
              </p>
            </div>
            <div
              ref={mapContainerRef}
              style={{ height: "600px", width: "100%" }}
              className="google-map-container"
            />
          </div>
        </div>
      </div>

      {/* Tabla Compacta */}
      <div className="bg-white/70 backdrop-blur-md rounded-xl shadow-lg border border-white/20 overflow-hidden">
        {/* Header de la tabla compacto */}
        <div className="bg-gradient-to-r from-indigo-500 to-purple-500 px-4 py-3 text-white">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-lg font-bold flex items-center">
                <Filter className="mr-2 h-5 w-5" />
                Geocercas Configuradas
              </h3>
              <p className="text-indigo-100 mt-0.5 text-sm">
                Lista de zonas geográficas creadas
              </p>
            </div>
            <div className="bg-white/20 backdrop-blur-sm rounded-lg px-2 py-1">
              <span className="text-xs font-medium">
                Total: {window.geofences ? window.geofences.length : 0}
              </span>
            </div>
          </div>
        </div>

        {/* Controles compactos */}
        <div className="p-3 border-b border-gray-200 bg-gray-50/50">
          <div className="flex flex-col sm:flex-row gap-2 items-start sm:items-center justify-between">
            <div className="flex-1 max-w-md">
              <div className="relative group">
                <Search className="absolute left-2 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400 group-focus-within:text-blue-500 transition-colors" />
                <input
                  type="text"
                  placeholder="Buscar por nombre o ID..."
                  value={tableSearchQuery}
                  onChange={(e) => setTableSearchQuery(e.target.value)}
                  className="w-full pl-8 pr-3 py-1.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white/70 backdrop-blur-sm transition-all text-sm"
                />
              </div>
            </div>

            <div className="flex items-center gap-2 text-sm">
              <span className="text-gray-600">Mostrar:</span>
              <select
                value={itemsPerPage}
                onChange={(e) => {
                  setItemsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
                className="border border-gray-300 rounded px-2 py-1 bg-white/70 backdrop-blur-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
              </select>
            </div>
          </div>
        </div>

        {/* Tabla compacta */}
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-100/70 backdrop-blur-sm">
              <tr>
                <th className="px-3 py-2 text-center text-xs font-semibold text-gray-700 select-none">
                  #
                </th>

                {/* 🔹 Columna Nombre (orden inicial por defecto) */}
                <th
                  className="px-3 py-2 text-left text-xs font-semibold text-gray-700 cursor-pointer hover:bg-gray-200/50 transition-colors"
                  onClick={() => handleSort("name")}
                >
                  <div className="flex items-center gap-1">
                    Nombre
                    {sortField === "name" ? (
                      sortDirection === "asc" ? (
                        <ChevronUp className="h-3.5 w-3.5 text-blue-600" />
                      ) : (
                        <ChevronDown className="h-3.5 w-3.5 text-blue-600" />
                      )
                    ) : (
                      <ChevronsUpDown className="h-3.5 w-3.5 text-gray-400" />
                    )}
                  </div>
                </th>

                {/* 🔹 Columna Puntos (ordenable) */}
                <th
                  className="px-3 py-2 text-left text-xs font-semibold text-gray-700 cursor-pointer hover:bg-gray-200/50 transition-colors"
                  onClick={() => handleSort("points")}
                >
                  <div className="flex items-center gap-1">
                    Puntos
                    {sortField === "points" ? (
                      sortDirection === "asc" ? (
                        <ChevronUp className="h-3.5 w-3.5 text-blue-600" />
                      ) : (
                        <ChevronDown className="h-3.5 w-3.5 text-blue-600" />
                      )
                    ) : (
                      <ChevronsUpDown className="h-3.5 w-3.5 text-gray-400" />
                    )}
                  </div>
                </th>

                <th className="px-3 py-2 text-center text-xs font-semibold text-gray-700">
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200/50">
              {getPaginatedData().map((geofence, index) => {
                const points = JSON.parse(geofence.points || "[]");
                const correlativo =
                  (currentPage - 1) * itemsPerPage + (index + 1);
                return (
                  <tr
                    key={geofence.id}
                    className="hover:bg-blue-50/50 transition-colors"
                  >
                    {/* Correlativo visual */}
                    <td className="px-3 py-2 text-center">
                      <span className="inline-flex items-center justify-center w-6 h-6 rounded-full text-xs font-semibold bg-blue-100 text-blue-800">
                        {correlativo}
                      </span>
                    </td>

                    <td className="px-3 py-2">
                      <div className="flex items-center">
                        <MapPin className="h-3 w-3 text-blue-500 mr-1" />
                        <span className="text-xs font-medium text-gray-900">
                          {geofence.name}
                        </span>
                      </div>
                    </td>

                    <td className="px-3 py-2">
                      <span className="inline-flex items-center px-1.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                        {points.length} pts
                      </span>
                    </td>

                    <td className="px-3 py-2 text-center">
                      <div className="flex justify-center items-center gap-1">
                        <button
                          onClick={() => window.zoomToGeofence(geofence.id)}
                          title="Ver en mapa"
                          className="p-1.5 rounded-lg bg-blue-100 hover:bg-blue-200 text-blue-600 transition-all hover:scale-110"
                        >
                          <Eye className="h-4 w-4" />
                        </button>

                        <button
                          onClick={() => startEditingGeofence(geofence.id)}
                          title="Editar polígono"
                          disabled={isEditing || isDrawing}
                          className={`p-1.5 rounded-lg bg-amber-100 hover:bg-amber-200 text-amber-600 transition-all hover:scale-110 ${
                            isEditing || isDrawing
                              ? "opacity-50 cursor-not-allowed"
                              : ""
                          }`}
                        >
                          <Edit className="h-4 w-4" />
                        </button>

                        <button
                          onClick={() => abrirModalAsignar(geofence)}
                          title="Asignar establecimiento"
                          className="p-1.5 rounded-lg bg-purple-100 hover:bg-purple-200 text-purple-600 transition-all hover:scale-110"
                        >
                          <Building2 className="h-4 w-4" />
                        </button>

                        <button
                          onClick={() => window.deleteGeofence(geofence.id)}
                          title="Eliminar"
                          disabled={
                            isEditing && editingGeofence?.id === geofence.id
                          }
                          className={`p-1.5 rounded-lg bg-red-100 hover:bg-red-200 text-red-600 transition-all hover:scale-110 ${
                            isEditing && editingGeofence?.id === geofence.id
                              ? "opacity-50 cursor-not-allowed"
                              : ""
                          }`}
                        >
                          <Trash2 className="h-4 w-4" />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {/* Mensaje cuando no hay resultados */}
          {getPaginatedData().length === 0 && (
            <div className="text-center py-8">
              <Search className="h-8 w-8 text-gray-400 mx-auto mb-2" />
              <h3 className="text-sm font-medium text-gray-900 mb-1">
                No se encontraron geocercas
              </h3>
              <p className="text-gray-600 text-xs">
                {tableSearchQuery
                  ? `No hay geocercas que coincidan con "${tableSearchQuery}"`
                  : "No hay geocercas configuradas todavía"}
              </p>
            </div>
          )}
        </div>

        {/* Paginación compacta */}
        {getTotalPages() > 1 && (
          <div className="px-3 py-2 bg-gray-50/50 border-t border-gray-200 flex items-center justify-between">
            <div className="text-xs text-gray-700">
              {(currentPage - 1) * itemsPerPage + 1} a{" "}
              {Math.min(
                currentPage * itemsPerPage,
                filterAndSortGeofences().length,
              )}{" "}
              de {filterAndSortGeofences().length}
            </div>

            <div className="flex items-center gap-1">
              <button
                onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                disabled={currentPage === 1}
                className="inline-flex items-center px-2 py-1 text-xs font-medium text-gray-700 bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all hover:scale-105"
              >
                <ChevronLeft className="h-3 w-3 mr-0.5" />
                Ant
              </button>

              <div className="flex items-center gap-0.5">
                {Array.from({ length: getTotalPages() }, (_, i) => i + 1).map(
                  (page) => (
                    <button
                      key={page}
                      onClick={() => setCurrentPage(page)}
                      className={`px-2 py-1 text-xs font-medium rounded transition-all hover:scale-105 ${
                        currentPage === page
                          ? "bg-blue-500 text-white"
                          : "text-gray-700 bg-white border border-gray-300 hover:bg-gray-50"
                      }`}
                    >
                      {page}
                    </button>
                  ),
                )}
              </div>

              <button
                onClick={() =>
                  setCurrentPage(Math.min(getTotalPages(), currentPage + 1))
                }
                disabled={currentPage === getTotalPages()}
                className="inline-flex items-center px-2 py-1 text-xs font-medium text-gray-700 bg-white border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all hover:scale-105"
              >
                Sig
                <ChevronRight className="h-3 w-3 ml-0.5" />
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Footer compacto */}
      <div className="mt-3 bg-white/70 backdrop-blur-md p-3 rounded-xl shadow-lg border border-white/20 text-center">
        <p className="text-gray-600 text-sm">
          <span className="font-semibold">Sistema de Geocercas</span> - Gestión
          avanzada de zonas geográficas
        </p>
        <div className="flex justify-center items-center gap-3 mt-1 text-xs text-gray-500">
          <span className="flex items-center gap-1">
            <MapPin className="h-3 w-3" />
            Google Maps API
          </span>
          <span className="flex items-center gap-1">
            <Layers className="h-3 w-3" />
            Polígonos Interactivos
          </span>
          <span className="flex items-center gap-1">
            <Search className="h-3 w-3" />
            Búsqueda Localizada
          </span>
        </div>
      </div>

      {modalOpen && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 animate-fadeIn">
          <div className="bg-gradient-to-br from-blue-50 via-white to-indigo-50 rounded-xl shadow-2xl w-full max-w-2xl p-6 border border-white/30 relative animate-fadeInUp">
            {/* Botón cerrar */}
            <button
              onClick={() => setModalOpen(false)}
              className="absolute top-3 right-3 text-gray-400 hover:text-gray-700 transition"
            >
              <X className="h-5 w-5" />
            </button>

            {/* Título */}
            <div className="flex items-center justify-between mb-4 mt-3">
              <div className="flex items-center gap-2">
                <MapPin className="h-5 w-5 text-indigo-500" />
                <h3 className="text-lg font-bold text-gray-800">
                  {geofenceSeleccionada?.name || "Geocerca"}
                </h3>
              </div>

              <button
                onClick={async () => {
                  if (!agregando) {
                    setCargandoEstablecimientos(true);
                    setDescripcion(geofenceSeleccionada?.name || "");
                    try {
                      await fetchEstablecimientos();
                    } catch (error) {
                      console.error(
                        "❌ Error cargando establecimientos:",
                        error,
                      );
                    } finally {
                      setTimeout(() => setCargandoEstablecimientos(false), 500);
                    }
                  }
                  setAgregando(!agregando);
                }}
                className="flex items-center gap-1 px-3 py-1.5 text-sm rounded-lg bg-gradient-to-r from-blue-500 to-indigo-500 text-white hover:from-blue-600 hover:to-indigo-600 transition"
              >
                {agregando ? (
                  <>
                    <Minus className="w-4 h-4" /> Cancelar
                  </>
                ) : (
                  <>
                    <Plus className="w-4 h-4" /> Agregar
                  </>
                )}
              </button>
            </div>

            {/* Lista de establecimientos existentes */}
            <div className="bg-white/70 rounded-lg border border-gray-200 shadow-inner p-3 max-h-60 overflow-y-auto mb-4">
              {cargandoAsignaciones ? (
                <div className="flex flex-col items-center justify-center py-8 bg-gradient-to-r from-blue-100/40 to-indigo-100/40 rounded-lg">
                  <svg
                    className="animate-spin h-8 w-8 text-blue-600 mb-3"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                    ></path>
                  </svg>
                  <p className="text-sm font-medium text-gray-700 animate-pulse">
                    Cargando asignaciones...
                  </p>
                </div>
              ) : asignaciones.length > 0 ? (
                <ul className="space-y-2">
                  {asignaciones.map((asig) => (
                    <li
                      key={asig.id || asig.id_uuid}
                      className="flex justify-between items-center bg-white rounded-lg shadow-sm border border-gray-100 p-2.5 hover:shadow-md transition text-sm"
                    >
                      <div className="flex flex-wrap items-center gap-1 text-gray-800">
                        <span className="font-semibold">
                          🏢 {asig.establecimiento?.nombre || "Sin nombre"}
                        </span>
                        <span className="text-gray-400">—</span>
                        <span
                          className={`font-medium ${
                            asig.tipo === "INTERNA"
                              ? "text-blue-600"
                              : "text-indigo-600"
                          }`}
                        >
                          {asig.tipo}
                        </span>
                        {asig.descripcion && (
                          <>
                            <span className="text-gray-400">—</span>
                            <span className="text-gray-600">
                              {asig.descripcion}
                            </span>
                          </>
                        )}
                      </div>

                      <button
                        onClick={() =>
                          eliminarAsignacion(asig.id_uuid || asig.id)
                        }
                        className="text-red-500 hover:text-red-700 transition"
                        title="Eliminar asignación"
                      >
                        <Trash2 className="h-4 w-4" />
                      </button>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-sm text-gray-500 italic text-center py-3">
                  No hay establecimientos asignados.
                </p>
              )}
            </div>

            {/* Sección para agregar nueva asignación */}
            {agregando && (
              <div className="border-t border-gray-200 pt-4 animate-fadeIn">
                {cargandoEstablecimientos ? (
                  <div className="flex flex-col items-center justify-center py-8 bg-gradient-to-r from-blue-100/40 to-indigo-100/40 rounded-lg">
                    <svg
                      className="animate-spin h-8 w-8 text-blue-600 mb-3"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                      ></path>
                    </svg>
                    <p className="text-sm font-medium text-gray-700 animate-pulse">
                      Cargando establecimientos disponibles...
                    </p>
                  </div>
                ) : (
                  <>
                    {/* Select de establecimientos */}
                    <label className="text-sm font-medium text-gray-700 mb-1 block">
                      Selecciona un establecimiento
                    </label>
                    <Select
                      options={establecimientos}
                      value={establecimientoSeleccionado}
                      onChange={setEstablecimientoSeleccionado}
                      placeholder="Buscar establecimiento..."
                      isSearchable
                      className="text-sm mb-4"
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderRadius: "0.5rem",
                          borderColor: "#d1d5db",
                          boxShadow: "none",
                          "&:hover": { borderColor: "#2563eb" },
                        }),
                        menu: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />

                    {/* Selector de tipo */}
                    <label className="text-sm font-medium text-gray-700 mb-1 block">
                      Tipo de Geocerca
                    </label>
                    <select
                      value={tipoGeocerca}
                      onChange={(e) => setTipoGeocerca(e.target.value)}
                      className="w-full mb-3 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm bg-white/70"
                    >
                      <option value="INTERNA">INTERNA</option>
                      <option value="EXTERNA">EXTERNA</option>
                    </select>

                    {/* Campo descripción */}
                    <label className="text-sm font-medium text-gray-700 mb-1 block">
                      Descripción
                    </label>
                    <input
                      type="text"
                      value={descripcion}
                      onChange={(e) => setDescripcion(e.target.value)}
                      className="w-full mb-3 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm bg-white/70"
                    />

                    {/* Botones */}
                    <div className="flex justify-end gap-2">
                      <button
                        onClick={() => setAgregando(false)}
                        className="px-3 py-1.5 rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-700 text-sm"
                      >
                        Cancelar
                      </button>
                      <button
                        onClick={asignarEstablecimiento}
                        disabled={asignando}
                        className="px-4 py-1.5 rounded-lg bg-gradient-to-r from-blue-500 to-indigo-500 text-white text-sm font-medium hover:from-blue-600 hover:to-indigo-600 disabled:opacity-50"
                      >
                        {asignando ? "Asignando..." : "Asignar"}
                      </button>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default GeofencesGoogleMaps;
